
/*
 * Date: 2025
 * Description: Archives rows to manage scripts
 * Author: Philippe Leroux @ Skitsc
 */

//Modules
import { ReactElement } from "react";
import { Box , Grid , Typography , IconButton , Tooltip } from "@mui/material";

//Interfaces
import { i_table_row_props } from "../../interfaces/utility.interface";

//Utils
import { timestampToDate } from "../../utils/utility";

//Icons
import VisibilityIcon from '@mui/icons-material/Visibility';
import ClearIcon from '@mui/icons-material/Clear';

const ArchivesRows = ( props : i_table_row_props ) : ReactElement => {
    const H = props.headers
    const R = props.row
    return (
      <Box sx={{ borderLeft : '1px solid #D3D3D3' , borderRight : '1px solid #D3D3D3' , borderBottom : '1px solid #D3D3D3'}}>
            <Grid container sx={{ padding : '6px'}}>
                <Grid size={H[0].portion} sx={{ opacity : 1}}>
                    <Box sx={{ display : 'flex' , marginTop : '0.7vh' }}>
                        <Typography sx={{  alignSelf : 'center' , fontSize : 14 }}>{timestampToDate(Number(R.timestamp) , 'long')}</Typography>
                    </Box>
                </Grid>
                <Grid size={H[1].portion} sx={{ alignSelf : 'center'}}>
                        <Typography sx={{ alignSelf : 'center' , fontSize : 14 }}>{R.type}</Typography>
                </Grid>
                <Grid size={H[2].portion} sx={{ alignSelf : 'center' }}>
                    <Tooltip title={"Show"}>
                        <IconButton sx={{ opacity : 1}} onClick={() => props.callback(R , 'view')}><VisibilityIcon sx={{ }}/></IconButton>
                    </Tooltip>
                    <Tooltip title={'Kill'}>
                        <IconButton sx={{ opacity : 1}} onClick={() => props.callback(R , 'delete')}> <ClearIcon sx={{ color : 'red'}}/> </IconButton>
                    </Tooltip>
                </Grid>
            </Grid>
        </Box>
    )
}

export default ArchivesRows;